import React from 'react';
import { Chip } from '@milanote/roma';

import EmojiImage from '../../../components/emoji/EmojiImage';
import ElementReactionPillTooltip from '../../reactions/ElementReactionPillTooltip';
import { getChipClassNames } from './elementChipClassNames';
import type { ElementChipProps } from './elementChipTypes';

/**
 * Renders a reaction pill for the generic element pills path.
 */
const ReactionChip: React.FC<Extract<ElementChipProps, { type: 'reaction' }>> = ({
    emojiCode,
    userIds,
    currentUserId = '',
    isSelected,
    isSearchHighlighted,
}) => (
    <ElementReactionPillTooltip emojiCode={emojiCode} currentUserId={currentUserId} userIds={userIds}>
        <Chip
            className={getChipClassNames(isSelected, Boolean(isSearchHighlighted))}
            variant={userIds.includes(currentUserId) ? 'user' : 'normal'}
            count={userIds.length}
        >
            <EmojiImage emojiCode={emojiCode} className="size-3" />
        </Chip>
    </ElementReactionPillTooltip>
);

export default ReactionChip;
